export default {
	title: "Fichas de Atendimento",
	cards: "Fichas de Atendimento",
	newCard: "Vincular Atendimento",
	editCard: "Editar Vínculo",
	deleteCard: "Remover Vínculo",
	noCards: "Nenhum atendimento vinculado",
	noCardsDescription: "Vincule tipos de atendimento para configurar as fichas deste ritual",
	overridden: "Sobrescrito",
	copyFrom: "Copiar Vínculos",
	copyFromTitle: "Copiar Vínculos de Outro Ritual",
	copyFromHint: "Selecione um tipo de ritual para copiar seus vínculos de atendimento",
	copyFromPlaceholder: "Selecione o tipo de ritual de origem",
	form: {
		attendanceTypeLabel: "Tipo de Atendimento",
		attendanceTypeHint: "Selecione o tipo de atendimento para vincular a este ritual",
		maxTicketsOverrideLabel: "Limite de Fichas (sobrescrever)",
		maxTicketsOverrideHint: "Deixe vazio para usar o padrão do tipo de atendimento",
		typeInfo: "Configuração do tipo",
		defaultMaxTickets: "Padrão",
		hasQueueLabel: "Possui Fila",
	},
	numberingModes: {
		INCREMENTAL: "Sob demanda",
		PRE_DEFINED: "Fixa",
		incrementalDescription: "Fichas são geradas sob demanda conforme novos consulentes chegam",
		preDefinedDescription: "Fichas são pré-definidas com posições fixas para cada médium",
	},
	messages: {
		created: "Atendimento vinculado com sucesso",
		updated: "Vínculo atualizado com sucesso",
		deleted: "Vínculo removido com sucesso",
		deleteError: "Erro ao remover vínculo",
		loadError: "Erro ao carregar fichas de atendimento",
		copied: "Vínculos copiados com sucesso",
		copyError: "Erro ao copiar vínculos",
	},
	deleteConfirmation: "Deseja realmente remover o vínculo com {label}?",
	deleteWarning: "Esta ação não pode ser desfeita.",
	validation: {
		attendanceTypeRequired: "Tipo de atendimento é obrigatório",
		maxTicketsMin: "Quantidade mínima é 1",
	},
};
